import { buildHardwareManifest, buildScratchpadLedger, materialLabel } from "./scratchpadModel";

const money = value => Number(value || 0).toLocaleString("en-CA", { style: "currency", currency: "CAD" });
const number = value => Number(value || 0).toLocaleString("en-CA", { maximumFractionDigits: 2 });

export const derivedExportTable = (tab, sections, settings) => {
  if (tab === "finishing") {
    const rows = buildScratchpadLedger(sections, settings).rows.map(row => ({
      cells: [
        `${row.item_code || "—"} / ${row.finish_required === "paint" ? "Paint" : "Stain"}`,
        row.description || "",
        row.line_kind === "linear" ? `${number(row.length)} ft` : `${row.raw_width || "—"} × ${row.raw_height || "—"}`,
        row.line_kind === "linear" ? `${number(row.linear_feet)} lin ft` : `${number(row.finished_width)}″ × ${number(row.finished_height)}″`,
        number(row.quantity), materialLabel(row.material), money(row.front_total), money(row.back_total), money(row.finishing_total),
      ],
    }));
    return { title: "Automated Finishing Ledger", headers: ["Product Code / Finish", "Item Name", "Basis", "Finished / Linear", "Qty", "Material", "Front Charge", "Back Charge", "Total"], rows };
  }
  const rows = buildHardwareManifest(sections).lines.map(line => ({
    cells: [line.item_name, line.size || "Bundled", number(line.quantity), line.breakdown ? Object.entries(line.breakdown).map(([key, value]) => `${key.replaceAll("_", " ")}: ${number(value)}`).join(" · ") : ""],
  }));
  return { title: "Automated Hardware Manifest", headers: ["Inventory Item", "Size", "Quantity", "Breakdown"], rows };
};